import React, { useContext, useEffect } from "react";
import { usePdpProduct, usePdpActions } from "./PdpContext";
import { DroppsProduct } from "@/store";

const ProductRouterContext = React.createContext<true | undefined>(undefined);

interface HistoryProduct {
  product: DroppsProduct;
}

export const ProductRouter = ({ children }: React.PropsWithChildren<{}>) => {
  const product = usePdpProduct();
  const actions = usePdpActions();

  // Whenever someone hits the back button and the stored data
  // has a scent, restore the scent
  useEffect(() => {
    async function popHandler(event: PopStateEvent) {
      if (event.state?.product) {
        const prod = event.state as HistoryProduct;
        actions.focusProduct(prod.product);
      }
    }

    window.addEventListener("popstate", popHandler);
    return () => {
      window.removeEventListener("popstate", popHandler);
    };
  }, [actions]);

  useEffect(() => {
    const newUrl = new URL(document.URL);
    const newPath = `/products/${product.handle}`;
    if (newUrl.pathname == `/products/${product.handle}`) {
      return;
    }

    newUrl.pathname = newPath;
    document.title = product.title;
    const state: HistoryProduct = { product };
    history.pushState(state, "", newUrl);
  }, [product]);

  return (
    <ProductRouterContext.Provider value={true}>
      {children}
    </ProductRouterContext.Provider>
  );
};

export const useHasProductRouter = () => !!useContext(ProductRouterContext);
